exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".active{color:#195500}.topNav{border:1px solid #c8ecff}.topNav li{margin-right:20px;display:inline-block}.ellipsisText{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/global/app.scss
// module id = 845
// module chunks = 0